import { HELP_HOME_URL } from "@/composables/useContextHelp";

export function openSupport() {
    if (typeof window.Tawk_API?.toggle === "function") {
        window.Tawk_API.toggle();
    } else {
        window.open(HELP_HOME_URL, "_blank", "noopener,noreferrer");
    }
}
